import { HTMLAttributes, ReactNode, memo } from 'react';
import { cn } from '@/lib/utils';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  children: ReactNode;
  footer?: ReactNode;
  /** Padding del contenido (default: true) */
  padding?: boolean;
}

/**
 * Card (memoized) - Componente contenedor con estilos Tailwind Plus
 * 
 * Mejoras aplicadas:
 * - Shadow más sutil (shadow-xs → shadow-sm)
 * - Dark mode semi-transparente (bg-gray-800/50)
 * - Ring inset para borde sutil
 * - overflow-hidden por defecto
 */
export const Card = memo(function Card({ title, children, footer, padding = true, className = '', ...props }: CardProps) {
  return (
    <div 
      className={cn(
        // Base
        'overflow-hidden rounded-lg bg-white shadow-sm',
        // Light mode: ring inset sutil
        'ring-1 ring-inset ring-black/5',
        // Dark mode: semi-transparente con ring
        'dark:bg-secondary-800/50 dark:shadow-none dark:ring-white/10',
        className
      )} 
      {...props}
    >
      {title && (
        <div className="px-6 py-4 border-b border-secondary-100 dark:border-white/5">
          <h3 className="text-lg font-semibold text-secondary-900 dark:text-white">{title}</h3>
        </div>
      )}
      <div className={padding ? 'px-6 py-4' : ''}>{children}</div>
      {footer && (
        <div className="px-6 py-4 border-t border-secondary-100 bg-secondary-50/50 dark:border-white/5 dark:bg-secondary-900/50">
          {footer}
        </div>
      )}
    </div>
  );
});
